import React from 'react';
import Tooltip from 'rc-tooltip';

interface Props {
  label: string;
  children: React.ReactElement;
}

export const CopyColorTooltip: React.FC<Props> = ({ label, children }) => (
  <Tooltip
    overlay={label}
    prefixCls="tooltip"
    destroyTooltipOnHide
    placement="top"
    overlayClassName="text-center"
    mouseLeaveDelay={0.01}
    align={{
      offset: [0, 5],
    }}
  >
    {children}
  </Tooltip>
);
